import { useCallback } from "react";
import { useScript } from "@hooks/useScript";
import { waitForVar } from "@utils/waitForVar";
import { ACCOUNT_SCORING_SCRIPT_URL } from "@/constants";

interface IAccountScoringSDK {
  client_id?: string;
  container_id?: string;
  invitation_id?: number;
  locale?: string;
  onTransactionsFetched?: (data: string) => void;
  vueapp?: unknown;
  initialize: (params: {
    container_id: string;
    invitation_id: number;
    client_id: string;
    locale: string;
    is_modal: boolean;
    onTransactionsFetched: (data: string) => void;
    // Confim all done is useless
    onConfirmAllDone?: (status: unknown) => void;
    // On close is also useless
    onClose?: () => void;
  }) => void;
}

export const useAccountScoringEmbed = () => {
  useScript(ACCOUNT_SCORING_SCRIPT_URL, { removeOnUnmount: true });

  const initiateConsent = useCallback(
    async (params: {
      containerId: string;
      invitationKey: number;
      clientId: string;
      locale: string;
      onTransactionsFetched: (data: unknown) => void;
    }) => {
      const accountScoringSDK = (await waitForVar(
        "ASCEMBED",
      )) as IAccountScoringSDK;

      accountScoringSDK.initialize({
        container_id: params.containerId,
        invitation_id: params.invitationKey,
        client_id: params.clientId,
        locale: params.locale,
        is_modal: false,
        onTransactionsFetched: params.onTransactionsFetched,
      });
    },
    [],
  );

  /**
   * Hack to clear the state of the SDK
   * Seems like devs didn't make this reusable
   */
  const clearState = useCallback(() => {
    // @ts-expect-error - c
    delete window.ASCEMBED;
  }, []);

  return { initiateConsent, clearState };
};
